import {
  AzureOfferPlan,
  AzurePricingType,
  RecurrentPriceModeType,
} from '../../modules/privateOffer/types'

export const getPriceTitleAndValue = ({
  azurePricingType,
  recurrentPriceMode,
  plan,
}: {
  azurePricingType?: AzurePricingType
  recurrentPriceMode?: RecurrentPriceModeType
  plan?: AzureOfferPlan
}) => {
  const isFlexiblePayment =
    plan?.pricing?.recurrentPrice?.prices[0]?.installments?.schedule?.length
  const priceValue = isFlexiblePayment
    ? plan?.pricing?.recurrentPrice?.prices[0]?.installments?.tcv
    : plan?.pricing?.recurrentPrice?.prices[0]?.pricePerPaymentInUsd

  if (azurePricingType === AzurePricingType.LABRA_PERCENTAGE) {
    if (recurrentPriceMode === RecurrentPriceModeType.PERUSER) {
      return {
        title: 'Discount price per user',
        value: (isFlexiblePayment ? priceValue : priceValue) || undefined,
      }
    }
    return {
      title: 'Discount price',
      value: (isFlexiblePayment ? priceValue : priceValue) || undefined,
    }
  }

  if (recurrentPriceMode === RecurrentPriceModeType.PERUSER) {
    return { title: 'Price per user', value: priceValue || undefined }
  }
  return { title: 'Total contract value', value: priceValue || undefined }
}
